

<div class="card i-box-shadow">
    <h4 class="card-header">Login</h4>
    <div class="card-body">
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group">
                <label for="username">Email</label>
                <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" autocomplete="on" />
                <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                    <div *ngIf="f.username.errors.required">Email is required</div>
                </div>
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" autocomplete="on"/>
                <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                    <div *ngIf="f.password.errors.required">Password is required</div>
                </div>
            </div>

            <div  class="form-group" *ngIf="ch">

              <ngx-recaptcha2 #captchaElem
                              [siteKey]="siteKey"  formControlName="recaptcha">
                           
              </ngx-recaptcha2>
            </div>
            <div class="form-group">
                <button [disabled]="loading" class="btn btn-primary">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    Login
                </button>
                <a class="ml-3" href="javascript:void(0)" (click)="openForgetPasswordDialog()" > Forgot password?</a>
            </div>
        </form>
    </div>
</div>
<!--<button (click)="sendTest()">send</button>-->
